/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const scenarioInFlightOperationResponseSchema = z.object({
  id: z.int(),
  queuedAt: z.iso.datetime(),
  status: z.enum(['QUEUED', 'RUNNING', 'SUCCEEDED', 'FAILED', 'EXPIRED']),
  type: z.enum(['SYNC', 'RESET', 'ACTIVATE']),
});
